module.exports = __webpack_public_path__ + "static/img/weather48.fc79379a.png";